import { Injectable } from '@angular/core'
import { ReportPeriods } from '@mg-platform/core/core-data-access'
import { IRangeDateInfo, IRangeDateValue } from '@mg-platform/core/core-feature'
import moment, { Moment } from 'moment'

@Injectable({
  providedIn: 'root'
})
export class DateService {
  convertToDateString(date: Date | undefined) {
    if (!date) {
      return
    }
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
  }

  momentToDateString(date: string | Date | Moment | undefined) {
    if (!date) {
      return
    }
    return moment(date).utc().format().split('T')[0]
  }

  momentCalculatedFormattedPeriod(rangeDate: IRangeDateValue | undefined, withoutYear = false) {
    let formattedPeriodTime = ''
    if (!rangeDate || !rangeDate?.from || !rangeDate?.to) {
      return
    }

    const { from, to } = {
      from: moment(rangeDate.from).utc(),
      to: moment(rangeDate.to).utc()
    }
    formattedPeriodTime +=
      from.isSame(to, 'year') || withoutYear ? from.format('MMM D') : from.format('MMM D, YYYY')
    formattedPeriodTime += ` - ${withoutYear ? to.format('MMM D') : to.format('MMM D, YYYY')}`

    return formattedPeriodTime
  }

  tooltipFormattedDate(
    dateString: string,
    selectedPeriod: ReportPeriods,
    selectedDateInfo: IRangeDateInfo,
    dataIndex: number,
    dateFormat: string,
    fullDataLength: number
  ) {
    let tooltipFormattedDate = moment(dateString).format(dateFormat)
    if (selectedPeriod === 'weekly') {
      const maxDataIndex = fullDataLength - 1
      if (selectedDateInfo.rangeDate && (dataIndex === 0 || dataIndex === maxDataIndex)) {
        const { from, to } = selectedDateInfo.rangeDate
        const startOfWeek = moment
          .max(moment(from).utc(), moment(dateString).startOf('week').utcOffset(0, true))
          .format(dateFormat)

        const endOfWeek = moment
          .min(moment(to).utc(), moment(dateString).endOf('week').utcOffset(0, true))
          .format(dateFormat)
        tooltipFormattedDate = `${startOfWeek} - ${endOfWeek}`
      } else {
        tooltipFormattedDate = `${moment(dateString).startOf('week').format(dateFormat)} - ${moment(dateString).endOf('week').format(dateFormat)}`
      }
    } else if (selectedPeriod === 'monthly') {
      tooltipFormattedDate = moment(dateString).format('MMMM, YYYY')
    } else if (selectedPeriod === 'yearly') {
      tooltipFormattedDate = moment(dateString).format('YYYY')
    }

    return tooltipFormattedDate
  }
}
